import React, { useState, useEffect } from "react";
import { Card, Row, Col, Modal, Spin, Table, Pagination } from "antd";
import { RiDeleteBin2Fill } from "react-icons/ri";
import {
  getAllFeedbacksPaginated,
  deleteFeedbackById,
} from "@api/notification/feedback"; // Assuming this is your API call
import { SuccessNotification, ErrorNotification } from "@components";

const FeedbacksList = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10, // Set your default page size
    total: 0,
  });

  useEffect(() => {
    fetchFeedbacks();
  }, [pagination.current, pagination.pageSize]);

  // Fetch all feedbacks with pagination
  const fetchFeedbacks = async (
    page = pagination.current,
    pageSize = pagination.pageSize
  ) => {
    setLoading(true);
    try {
      const res = await getAllFeedbacksPaginated(page, pageSize);
      setFeedbacks(res.data.feedbacks);
      setPagination((p) => ({
        ...p,
        total: res.data.paginationData.totalFeedbacks,
        current: res.data.paginationData.page, // Update current page if needed
        pageSize: res.data.paginationData.perPage, // Update page size if needed
      }));
    } catch (error) {
      ErrorNotification("Error fetching feedbacks");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Handle feedback delete
  const handleFeedbackDelete = (id) => {
    Modal.confirm({
      title: "Are you sure you want to delete this feedback?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: async () => {
        try {
          await deleteFeedbackById(id);
          SuccessNotification("Feedback deleted successfully");
          fetchFeedbacks();
        } catch (error) {
          ErrorNotification("Error deleting feedback");
          console.error(error);
        }
      },
    });
  };

  // Define table columns
  const columns = [
    {
      title: "Name",
      dataIndex: ["user", "name"],
      key: "name",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Email",
      dataIndex: ["user", "email"],
      key: "email",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Rating",
      dataIndex: ["payload", "rating"],
      key: "rating",
      render: (text) => <span>{text}</span>, // Adjust the rendering as needed
    },
    {
      title: "Message",
      dataIndex: ["payload", "message"],
      key: "message",
      render: (text) =>
        text.length > 50 ? text.substring(0, 50) + "..." : text,
    },
    {
      title: "URL",
      dataIndex: ["payload", "pageUrl"],
      key: "url",
      render: (text) => (
        <a href={text} target="_blank" rel="noopener noreferrer">
          {text.length > 50 ? text.substring(0, 50) + "..." : text}
        </a>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <RiDeleteBin2Fill
          onClick={() => handleFeedbackDelete(record._id)}
          style={{ cursor: "pointer", color: "red" }}
        />
      ),
    },
  ];

  // Pagination change handler
  const handlePaginationChange = (page, pageSize) => {
    setPagination({
      ...pagination,
      current: page,
      pageSize,
    });
    fetchFeedbacks(page, pageSize);
  };

  return (
    <>
      <Card style={{ borderRadius: "0", height: "100vh" }}>
        <Row>
          <Col span={24}>
            <h3 className="hp-mb-16">Feedbacks List</h3>
            {loading ? (
              <Spin
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "calc(80vh - 50px)",
                }}
              />
            ) : (
              <>
                <Table
                  columns={columns}
                  dataSource={feedbacks}
                  rowKey={(record) => record._id}
                  pagination={false} // Disable built-in pagination
                />
                <Pagination
                  current={pagination.current}
                  pageSize={pagination.pageSize}
                  total={pagination.total}
                  onChange={handlePaginationChange}
                  style={{ marginTop: 16, textAlign: "right" }}
                />
              </>
            )}
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default FeedbacksList;
